// extracted by mini-css-extract-plugin
export var banner = "_2l-0";
export var icon = "_2l-1";
export var message = "_2l-2";